import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

export default function GoogleBusinessCallback() {
  const [state, setState] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("Finishing your Google Business Profile connection…");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const oauthState = params.get("state");
      const providerError = params.get("error");
      if (providerError || !code || !oauthState) {
        setState("error");
        setMessage(providerError ? `Google did not connect: ${providerError}` : "The Google connection link was incomplete.");
        return;
      }
      const { data: session } = await supabase.auth.getSession();
      const { data, error } = await supabase.functions.invoke("google-business-profile", {
        body: { action: "connect_oauth", code, state: oauthState, redirect_uri: `${window.location.origin}/oauth/google-business` },
        headers: session.session ? { Authorization: `Bearer ${session.session.access_token}` } : undefined,
      });
      if (cancelled) return;
      if (error || data?.error) {
        setState("error");
        setMessage(String(data?.detail ?? data?.error ?? error?.message ?? "Google could not be connected."));
        return;
      }
      window.history.replaceState(null, "", window.location.pathname);
      setState("success");
      setMessage(`${Number(data?.locations_found ?? 0)} Google location(s) connected. The first review check has been requested.`);
    })();
    return () => { cancelled = true; };
  }, []);

  return <main className="flex min-h-screen items-center justify-center bg-muted/30 p-4"><div className="w-full max-w-lg rounded-2xl border bg-background p-8 text-center shadow-sm">
    {state === "loading" ? <Loader2 className="mx-auto h-9 w-9 animate-spin text-primary" /> : state === "success" ? <CheckCircle2 className="mx-auto h-9 w-9 text-emerald-600" /> : <XCircle className="mx-auto h-9 w-9 text-red-600" />}
    <h1 className="mt-4 text-xl font-semibold">{state === "loading" ? "Connecting Google" : state === "success" ? "Google is connected" : "Connection not completed"}</h1>
    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{message}</p>
    {state !== "loading" && <Button className="mt-6" onClick={() => window.location.assign("/?tab=crisis")}>Return to complaint recovery</Button>}
  </div></main>;
}
